import { render, staticRenderFns } from "./BINCardDocuments.vue?vue&type=template&id=31f6b416&lang=pug&"
import script from "./BINCardDocuments.vue?vue&type=script&lang=js&"
export * from "./BINCardDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports